import { atom } from "xoid";
import { useAtom } from "@xoid/react";

const authTokenAtom = atom<string | null>(
  (localStorage.getItem("auth_token") as string) ?? null,
);

export function useToken(): string | null {
  return useAtom(authTokenAtom);
}

export function setToken(token: string | null) {
  if (token === null) {
    localStorage.removeItem("auth_token");
  } else {
    localStorage.setItem("auth_token", token);
  }

  authTokenAtom.set(token);
}

export function getToken(): string | null {
  return authTokenAtom.value;
}
